/**
 * <s-announcement> — Rotating announcement bar.
 * Children: [data-slide] elements; the active one gets [data-active], the others inert.
 * Attributes: data-interval (ms, default 4500). Pauses while hovered or focused and
 * when the tab is hidden.
 */
class SAnnouncement extends HTMLElement {
  #timer = 0;
  #index = 0;
  #paused = false;
  #controller = null;

  connectedCallback() {
    const slides = this.#slides();
    if (slides.length < 2) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#show(0);
    const pause = () => { this.#paused = true; };
    const resume = () => { this.#paused = false; };
    this.addEventListener('pointerenter', pause, { signal });
    this.addEventListener('pointerleave', resume, { signal });
    this.addEventListener('focusin', pause, { signal });
    this.addEventListener('focusout', resume, { signal });
    this.#timer = window.setInterval(() => {
      if (this.#paused || document.hidden) return;
      this.#show((this.#index + 1) % this.#slides().length);
    }, Number(this.dataset.interval) || 4500);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
    this.#controller?.abort();
  }

  #slides() {
    return [...this.querySelectorAll('[data-slide]')];
  }

  #show(index) {
    this.#index = index;
    this.#slides().forEach((slide, i) => {
      slide.toggleAttribute('data-active', i === index);
      slide.inert = i !== index;
    });
  }
}

if (!customElements.get('s-announcement')) customElements.define('s-announcement', SAnnouncement);
